import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { SHELL_ROUTES } from './modules/shell/shell-routing.module';

const routes: Routes = [
  ...SHELL_ROUTES
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
